import styled from "styled-components";

export const StoreListStyled = styled.div`
  padding: 24rem;
  background: #f2f2f2;
  flex: 1;
`;
